/**
 * axios 오류 또는 Redux thunk reject 값에서 사용자용 메시지 추출.
 * 백엔드가 `{ success, error: { code, message } }` 또는 `{ error: string }` 형태를 섞어 써도 처리.
 *
 * @param {unknown} err
 * @param {string} [fallback]
 * @returns {string}
 */
export function getApiErrorMessage(err, fallback = '요청에 실패했습니다.') {
  if (err == null) return fallback;
  if (typeof err === 'string') return err || fallback;

  if (typeof err === 'object') {
    const data = err.response?.data;
    if (data) {
      if (typeof data.error === 'string' && data.error) return data.error;
      if (data.error && typeof data.error.message === 'string' && data.error.message) {
        let m = data.error.message;
        if (Array.isArray(data.error.details) && data.error.details.length) {
          const extra = data.error.details.slice(0, 5).join('; ');
          if (extra) m = `${m} (${extra})`;
        }
        return m;
      }
      if (typeof data.message === 'string' && data.message) return data.message;
    }

    if (typeof err.message === 'string' && err.message && !err.message.startsWith('Request failed')) {
      return err.message;
    }

    const nested = err.error;
    if (typeof nested === 'string' && nested) return nested;
    if (nested && typeof nested === 'object' && typeof nested.message === 'string' && nested.message) {
      return nested.message;
    }
  }

  return fallback;
}
